import moment from "moment"
import React from "react"
import { Badge, Card, Col, ListGroup, Row } from "react-bootstrap"

export default function EncounterSatuSehat({
    getEncounter
}) {
    return (
        <>
            <Card className="mb-4 shadow-sm border-secondary">
                <Card.Header as="h6" className="bg-secondary text-white small">
                    📋 Encounter Info
                </Card.Header>
                <Card.Body>
                    <ListGroup variant="flush">
                        <ListGroup.Item className="small">
                            <span className="small">
                                <strong>🏥 Ruangan:</strong>{' '}
                                {getEncounter?.location?.[0]?.location?.display || '-'}
                            </span>
                        </ListGroup.Item>
                        <ListGroup.Item className="small">
                            <span className="small">
                                <strong>⏰ Waktu:</strong>{' '}
                                {getEncounter?.period?.start
                                    ? moment(getEncounter?.period?.start).format('DD MMM YYYY, HH:mm')
                                    : '-'}
                            </span>
                        </ListGroup.Item>
                        <ListGroup.Item className="small">
                            <span className="small">
                                <strong> 📌 Status:{' '} </strong>
                                <Badge bg="success" className="text-uppercase small">
                                    {getEncounter?.status || 'UNKNOWN'}
                                </Badge>
                            </span>
                        </ListGroup.Item>
                    </ListGroup>
                </Card.Body>
            </Card>
        </>
    )
}